import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { websocketAction } from 'features/websocket/websocketSlice'
import { RootState } from 'store'

interface SendInviteStatus {
    total_count: number
    processed_count: number
}

const WS = {
    sendInviteProcess: websocketAction<SendInviteStatus>('portal::bulk_send_invites_status')
}

const attendeeSlice = createSlice({
    name: 'AttendeeSlice',
    initialState: {
        bulkInvitesStatus: {
            total: 0,
            completed: 0,
            isMinimizing: false,
        }
    },
    reducers: {
        startCount: (state, { payload }: PayloadAction<number>) => {
            state.bulkInvitesStatus.total = payload
            state.bulkInvitesStatus.completed = 0
            state.bulkInvitesStatus.isMinimizing = false
        },
        setIsMinimizing: (state, { payload }: PayloadAction<boolean>) => {
            state.bulkInvitesStatus.isMinimizing = payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(WS.sendInviteProcess, (state, { payload }) => {
            state.bulkInvitesStatus.total = payload.total_count
            state.bulkInvitesStatus.completed = payload.processed_count
        })
    }
})

export const bulkInvitesStatusSelector = (state: RootState) => state.attendee.bulkInvitesStatus

export const { startCount, setIsMinimizing } = attendeeSlice.actions

export default attendeeSlice.reducer
